import wordDeclension from './word-declension';

export const formatTimerEvent = (
  days: number,
  hours: number,
  minutes: number,
  seconds: number
) => {
  const daySubstr = wordDeclension(days, 'день', 'дня', 'дней');
  const hoursSubstr = wordDeclension(hours, 'час', 'часа', 'часов');
  const minutesSubstr = wordDeclension(minutes, 'минута', 'минуты', 'минут');
  const secondsSubstr = wordDeclension(seconds, 'секунда', 'секунды', 'секунд');

  let resultText = '';

  if (days) {
    resultText = `${days} ${daySubstr}`;
    if (hours) {
      resultText += ` ${hours} ${hoursSubstr}`;
    }
  } else if (hours) {
    resultText = `${hours} ${hoursSubstr}`;
    if (minutes) {
      resultText += ` ${minutes} ${minutesSubstr}`;
    }
  } else if (minutes) {
    resultText = `${minutes} ${minutesSubstr}`;
    if (seconds) {
      resultText += ` ${seconds} ${secondsSubstr}`;
    }
  } else if (seconds) {
    resultText = `${seconds} ${secondsSubstr}`;
  } else {
    resultText = '';
  }

  return resultText;
};
